import DOMPurify from 'dompurify';

// Strict allow-list for user-authored bios. No scripts, no event handlers,
// no remote `<img src>` (we explicitly allow `src` only when needed elsewhere).
const ALLOWED_TAGS = [
  'a', 'b', 'i', 'em', 'strong', 'u', 'p', 'br', 'span', 'div',
  'ul', 'ol', 'li', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'code', 'pre', 'hr',
];
const ALLOWED_ATTR = ['href', 'title', 'target', 'rel', 'class'];

export function sanitizeBioHtml(raw) {
  if (!raw || typeof raw !== 'string') return '';
  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button', 'meta', 'link', 'svg'],
    FORBID_ATTR: ['style', 'srcdoc', 'srcset', 'src'],
  });
}

export default sanitizeBioHtml;
